import { uniqueId } from 'gleam-shared/helpers/nodash'

export function tokenizeMarkdown(markdown) {
  if (!markdown) {
    return []
  }

  // valid input: [hello@gleam.io](mailto:hello@gleam.io?subject=Happy%20New%20(2024)%20Year)
  const linkRE = /\[([^\]]+)\]\(([^\s[\]]+)\)/g
  const tokens = []

  let lastEnd = 0

  for (const match of markdown.matchAll(linkRE)) {
    const text = markdown.substring(lastEnd, match.index)
    const [tag, name, href] = match
    lastEnd = match.index + tag.length

    if (text) {
      tokens.push({ text })
    }

    tokens.push({ name, href })
  }

  const text = markdown.substring(lastEnd)

  if (text) {
    tokens.push({ text })
  }

  for (const token of tokens) {
    token.uid = uniqueId()
  }

  return tokens
}

export function stingifyMarkdown(markdown) {
  return stringifyTokens(tokenizeMarkdown(markdown))
}

function stringifyTokens(tokens) {
  let result = ''

  for (const { text, name } of tokens) {
    result += text ?? name
  }

  return result
}
